import React from 'react';
import PropTypes from 'prop-types';
import {SlideBlockContext} from '../SlideBlock';
import {Image} from '@learningblocks/shared-components';
import '../SharedComponents/Styles/DesignSlideJointGroup.scss';
import './style.scss';

/**
 * EndNode:
 *  - Component to disply the Output Node of DESIGN_SLIDE_THREE
 */
export function EndNode(props) {
  const {getTabIndex} = React.useContext(SlideBlockContext);

  const renderNode = (node, key) => (
    <Image
      key={key}
      tabIndex={getTabIndex()}
      src={node.image}
      alt={`endNode_${node.id}`}
    />
  );

  return (
    <div className='designSlide_jointGroup designSlide_endNode'>
      {props.outputNodes.map(renderNode)}
    </div>
  );
}

EndNode.propTypes = {
  /**
   * List of Output Node components
   */
  outputNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for the component
       */
      id: PropTypes.number.isRequired,
      /**
       * Url to hexagon shaped svg image
       */
      image: PropTypes.string.isRequired,
    })
  ),
};

EndNode.defaultProps = {
  outputNodes: [],
};
